import { servicesUsers } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { users as typesUsers, network } from 'types';

const useUserLock = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesUsers.TUserIdParams
    >({
        mutationFn: servicesUsers.lock,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useUserLock;
